<template>
  <div class="chart">
    <div class="bars">
      <div
        v-for="(bar, i) in bars"
        :key="i"
        class="bar-col"
      >
        <span class="bar-value" :style="{ color: barColor }">
          {{ bar.displayValue }}
        </span>
        <div class="bar-wrap">
          <div
            class="bar-fill"
            :style="{
              height: bar.pct + '%',
              background: `linear-gradient(to bottom, ${barColor}, ${barColor}40)`,
              boxShadow: `0 0 8px ${barColor}15`,
            }"
          />
        </div>
        <span class="bar-label">{{ bar.label }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue"

const props = defineProps({
  data:     { type: Array, default: () => [] },  // [{ value, label, displayValue? }]
  color:    { type: String, default: "#f5a623" },
  minPct:   { type: Number, default: 4 },         // minimum bar height %
})

const barColor = computed(() => props.color)

const bars = computed(() => {
  const maxVal = Math.max(...props.data.map((d) => d.value), 1)
  return props.data.map((d) => ({
    label:        d.label,
    displayValue: d.displayValue ?? (d.value === 0 ? "" : d.value),
    pct:          d.value === 0 ? 0 : Math.max((d.value / maxVal) * 100, props.minPct),
  }))
})
</script>

<style scoped>
.chart {
  width: 100%;
}

.bars {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  height: 80px;
}

.bar-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  height: 100%;
}

.bar-value {
  font-family: var(--font-mono);
  font-size: 8px;
  font-weight: 700;
  white-space: nowrap;
  min-height: 12px;
}

.bar-wrap {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: flex-end;
}

.bar-fill {
  width: 100%;
  border-radius: 3px 3px 0 0;
  transition: height 0.6s ease;
  min-height: 2px;
}

.bar-label {
  font-family: var(--font-mono);
  font-size: 8px;
  color: rgba(232, 230, 227, 0.25);
  white-space: nowrap;
}
</style>
